"use client";

import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web--source/slate/Layout";
import {
  Typography,
  TypographyStyles,
} from "@faire/web--source/slate/Typography";
import React from "react";
import styled, { css } from "styled-components";

import { Close } from "../icons/foundation/Close";
import { themeOrDefault } from "../Theme";
import { responsiveMediaQueries } from "../Theme/responsiveMediaQueries";
import {
  HIGH_VIS_FILTER,
  highVisSlateComponent,
} from "../utils/highVisSlateComponent";

export const Label = styled(Typography)`
  ${({ theme }) => TypographyStyles(theme.pills?.tag?.label ?? {})}
`;

export const Pill = styled(Row).attrs({ align: "center" })<{
  onClick?: () => void;
}>`
  padding: 2px 8px 2px 16px;
  min-height: 28px;
  ${({ theme, onClick }) => {
    const { pills } = themeOrDefault(theme);

    const regular = pills.tag.background.color;
    const hover = pills.tag.background.hover;
    const regularLetter = pills.tag.background.contrast;
    const pointer = onClick ? "pointer" : undefined;

    return css`
      cursor: ${pointer};
      background-color: ${regular};
      color: ${regularLetter};
      ${responsiveMediaQueries.desktopAndAbove} {
      &:hover {
        background-color: ${hover};
      }
    `;
  }};
  ${highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT)}
`;
Pill.displayName = "Pill";

const CloseContainer = styled(Row).attrs({
  align: "center",
  justify: "center",
})`
  width: 24px;
  height: 24px;
  padding: 7px;
  cursor: pointer;
`;

/* eslint-disable @faire/enforce-no-supersededby-components */
/**
 * @trackcomponent
 * @supersededBy "@faire/web--source/slate/IconButton/IconButton#IconButton"
 */
export const CloseButton: React.FC<{
  onClose: () => void;
  "data-test-id"?: string;
}> = (props) => {
  const handleClick: React.MouseEventHandler = (event) => {
    event.stopPropagation();
    event.preventDefault();
    props.onClose();
  };
  return (
    <CloseContainer onClick={handleClick} data-test-id={props["data-test-id"]}>
      <Close fontSize="8px" strokeWidth={2} color={Core.icon.default} />
    </CloseContainer>
  );
};
